import produce from 'immer';
import { CONFIG_STORAGE_KEY } from '../../constants/menu';
import { IMenuState, IMenuStateItem, TMenuActions } from '../../types/redux/menu';
import { SAVE_MENU_CHANGE, SAVE_MENU_DATA } from '../actions/menu';

const getInitialState = (): IMenuStateItem[] => {
    const val = window.localStorage.getItem(CONFIG_STORAGE_KEY);
    if (typeof val === 'string') {
        return JSON.parse(val);
    }
    return [];
};

const processCollapse = (arr: IMenuStateItem[]) => {
    const index = arr.findIndex((el) => el.type === 'collapse');

    if (index < 0) {
        arr.push({ type: 'collapse' });
    } else {
        arr.splice(index, 1);
    }

    return arr;
};

const initialState: IMenuState = {
    state: getInitialState(),
};

export const menu = (state = initialState, action: TMenuActions): IMenuState => {
    switch (action.type) {
        case SAVE_MENU_CHANGE: {
            return produce(state, (draft) => {
                if (action.payload.type === 'collapse') {
                    draft.state = processCollapse(draft.state);
                }
                window.localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(draft.state));
            });
        }
        case SAVE_MENU_DATA: {
            return produce(state, (draft) => {
                draft.data = action.payload;
            });
        }
        default: {
            return state;
        }
    }
};
